export default __webpack_public_path__ + "static/5-36268096b18482463e0088cba561ad86.jpeg";